/**
 * Centrally manages the API base URL.
 * It uses the VITE_API_URL environment variable,
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL;

if (!API_BASE_URL) {
  throw new Error("VITE_API_URL is not defined");
}
